import { Modal } from "antd";
import useBle from "../../Hooks/Ble";
import BleConexionControles from "./BleConexionControles";

/** Modal de conexión para pantallas de grabación de prueba. */
export default function BleConexionModal() {
    const {
        dispositivo,
        cargando,
        modalPruebaAbierto,
        cerrarModalPrueba,
        conectar,
        continuarSimulacion,
        omitirSoloBluetooth,
        simulacionVisible,
        esAdmin,
    } = useBle();

    const abierto = modalPruebaAbierto && !dispositivo;

    return (
        <Modal
            open={abierto}
            title="Conectar dispositivo"
            onCancel={cerrarModalPrueba}
            footer={null}
            maskClosable={false}
        >
            <BleConexionControles
                cargando={cargando}
                onConectar={conectar}
                onSimulacion={continuarSimulacion}
                onOmitir={omitirSoloBluetooth}
                simulacionVisible={simulacionVisible}
                esAdmin={esAdmin}
            />
        </Modal>
    );
}
